import jsFileDownload from 'js-file-download';
import axios from 'axios';
import { getToken } from '@/web-framework/api/token';
import UserAPI from "@/web-framework/api/user.js";
import router from '@/web-framework/router';

const ResourceIcon = {
    'iconfont icon-yushuexcel': 'jpg, jpeg, png, pneg,bmp,gif',
    'fa fa-video-camera': 'wmv,wm,asf,asx,rm,ram,mpg,mpeg,3gp,mp4,rmvb,mkv,avi,flv,f4v,vob',
    'yushuexcel': 'xls,xlsx',
    'fa fa-file-pdf-o': 'pdf',
    'el-icon-s-cooperation': 'jar,zip,gzip,7zip,tar,rar',
    'fa-file-word-o': 'doc,docx',
    'others': 'el-icon-tickets'
};

const ResourceAPI = {
    preview(id, isAttachement) {
        return `/api/storage/resources/fileDownload?unique=${id}&isAttachement`;
    },
    /**
     * 获取资源
     * @param {*} vm 
     * @param {*} pageNo 
     * @returns 
     */
    loadResources(query) {
        return Request.post(`/storage/resources/searchResources`, query);
    },
    search(query) {
        return Request.post(`/storage/resources/searchResources`, query);
    },
    /**
     * 获取资源信息
     */
    getResourceInfoByUnique(unique) {
        return Request.get('/storage/resources/getResourceInfoByUnique', { unique: unique });
    },
    downloadTemplate(name) {
        window.location = `/templates/${name}`;
    },
    download(unique, filename) {
        let url = "/storage/resources/filedownload?unique="
        if (unique !== undefined && unique !== "" && unique !== null) {
            url += encodeURI(unique)
        }
        if (filename !== undefined && filename !== "" && filename !== null) {
            url += "&filename=" + encodeURI(filename)
        }
        url += "&timestamp=" + new Date().getTime();

        axios({
            baseURL: '/api',
            withCredentials: true,
            url: url,
            method: 'post',
            headers: {
                'authorization': getToken(),
                'rid': UserAPI.getUserRole().id,
            },
            responseType: 'blob',
        }).then(res => {
            let downloadedFileName = filename;
            if (res.headers["content-disposition"]) {
                filename = res.headers["content-disposition"].split('=')[1];
                filename = filename.substring(1, filename.length - 1);
            }
            jsFileDownload(res.data, downloadedFileName);
        })
    },

    /**
     * 删除文件
     */
    removeResources(idArray) {
        return Request.post(`/storage/resources/deleteResources`, idArray);
    },
    /**
     * 获取转换状态
     * @param {*} status 
     */
    getVideoConvertStatus(status) {
        if (status == 0) {
            return '待转换';
        } else if (status == 1) {
            return '转换中';
        } else if (status == 2) {
            return '成功';
        } else {
            return '成功';
        }
    },
    /**
     * 获取图标
     * @param {*} filenameSuffix 
     */
    getIcon(filenameSuffix) {
        let keys = Object.keys(ResourceIcon);
        for (let i = 0; i < keys.length; i++) {
            if (ResourceIcon[keys[i]].indexOf(filenameSuffix) != -1) {
                return keys[i];
            }
        }
        return ResourceIcon.others;
    },
    /**
     * 审核通过
     * @param {*} id 
     * @returns 
     */
    auditApprove(id) {
        return Request.get(`/storage/resources/${id}/audit/approve`);
    },
    /**
     * 拒绝审核
     * @param {*} id 
     * @param {*} reason 
     * @returns 
     */
    auditReject(id, reason) {
        return Request.get(`/storage/resources/${id}/audit/reject`, { reason: reason });
    },

    /**
     * 审核通过
     * @param {*} id 
     * @returns 
     */
    batchAuditApprove(selectionIdArray) {
        return Request.post(`/storage/resources/batchAuditApprove`, selectionIdArray);
    },
    /**
     * 拒绝审核
     * @param {*} id 
     * @param {*} reason 
     * @returns 
     */
    batchAuditReject(selectionIdArray, reason) {
        return Request.post(`/storage/resources/batchAuditReject`, { reason: reason, idArray: selectionIdArray });
    }

};
export default ResourceAPI;